import React from 'react'
import Button from "../components/Button";
import { Helmet } from "react-helmet";

function GarhoudVillas() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Garhoud Villas | Al Ghaith Properties</title>
        <meta name="description" content="Discover modern living at Garhoud Villas. Spacious interiors, smart home technology, and eco-friendly materials in the heart of Dubai." />
        <link rel="canonical" href="https://www.al-ghaith.ae/projects/garhoudvillas" />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-r from-blue-50 to-blue-100 font-sans overflow-hidden">
        {/* Hero Section */}
        <section className="relative flex items-center justify-center h-screen">
          <div className="relative z-10 text-center text-white p-6 bg-black bg-opacity-50 rounded-xl shadow-xl">
            <h1 className="text-5xl font-bold mb-4">Welcome to Dream Property</h1>
            <p className="text-xl mb-6">Discover luxury and comfort in the heart of the city.</p>
            <div>
              <Button size="lg" className="text-lg px-8 py-4">Explore Now</Button>
            </div>
          </div>
        </section>

        {/* Info Section */}
        <section className="p-10 bg-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-semibold mb-4">Modern Design Meets Functionality</h2>
            <p className="text-gray-600 text-lg">
              Our property features spacious interiors, smart home technology, and eco-friendly materials. With easy access to local amenities and transportation, it's the perfect place to call home.
            </p>
          </div>
        </section>

        {/* Contact Section */}
        <section className="p-10 bg-blue-100">
          <div className="max-w-xl mx-auto text-center">
            <h3 className="text-3xl font-bold mb-4">Contact Us</h3>
            <p className="mb-6 text-gray-700">
              Interested in scheduling a tour or learning more? Fill out the form on our website or reach us at info@dreamproperty.com.
            </p>
            <Button size="lg" className="px-8 py-4">Get in Touch</Button>
          </div>
        </section>
      </div>
    </>
  );
}

export default GarhoudVillas;